// export type StoreLocatorProps = {};

import { Container } from 'components/gruenland/atoms/container/Container';
import { TYPOGRAPHY_MODULE_TITLE } from 'lib/typography';

export const ContactUs = () => {
  return (
    <Container>
      <h1 className={TYPOGRAPHY_MODULE_TITLE}>Contattaci</h1>
      <p>FORM</p>
    </Container>
  );
};
